<template>
  <Row :gutter="20" type="flex" class="grid-list-row">
    <Col
      v-for="(header,index) in headers"
      :key="index"
      :span="header.colSpan"
      :align="!header.subDetail || !values[header.subDetail.column]?'middle':''"
    >
      <p>
        <Ellipsis
          v-if="header.truncate"
          :text="values[header.column]"
          :length="header.truncate"
        />
        <span v-else-if="values[header.column]">{{values[header.column]}}</span>
        <span v-else>-</span>
        <small v-if="header.subDetail" :class="header.subDetail.class">
          <Ellipsis
            v-if="header.subDetail.truncate"
            :text="values[header.subDetail.column]"
            :length="header.subDetail.truncate"
          />
          <span v-else>{{values[header.subDetail.column]}}</span>
        </small>
      </p>
    </Col>
    <Col :span="7" class="col-push text-right">
      <div class="card-row-col card-col action_col invoices_col d-block">
        <div @click="showReasons()" class="pointer">
          <svgicon name="details" width="12" height="12" :original="true" />
          <span class="card-actionlabel">DETAILS</span>
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
import { formatDisplaySingleDate } from '@/lib/Date';

export default {
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    details: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      defualt: null,
    },
  },
  computed: {
    values() {
      const obj = {
        shipmentNumber: this.details.shipmentNumber,
        driverPhoneNumber: this.details.driverPhoneNumber,
        vehicleNumber: this.details.vehicleNumber,
        createdAt: formatDisplaySingleDate(this.details.created_at),
      };
      return obj;
    },
  },
  methods: {
    showReasons() {
      this.$emit('showReasons', this.index);
    },
  },
};
</script>
